<template>
  <div class="admin-root">
    <!-- The settings layout supplies the tree, the page header, the main
         landmark and the content column; this pane adds no nav, padding or
         width of its own. -->
    <RouterView />
  </div>
</template>
